export const EMPHATIC_MESSAGE = ''
export const ADDITIONAL_DETAILS =
  'This copyrighted material is meant for individual use only.'
export const DATA_TEST_ID = 'copyright-banner'
